import React, { useReducer } from "react";
import TagContext from "./tagContext";
import tagReducer from "./tagReducer";
import { API_BASE, apiErrorMessage, authedFetch } from "../../utils/api";

import {
  GET_TAGS,
  TAG_ERROR,
} from "../types";

const TagState = (props) => {
  const initialState = {
    tags: [],
    loading: true,
  };

  const [state, dispatch] = useReducer(tagReducer, initialState);

  // Get Contacts
  const getTags = async () => {
    const res = await authedFetch(`${API_BASE}/tags`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const res_json = await res.json();
    if (res.ok) {
      dispatch({ type: GET_TAGS, payload: res_json });
    } else {
      var error_msg = null;
      if (res.status === 401) {
        error_msg = "Unauthorized";
      } else {
        error_msg = apiErrorMessage(res_json);
      }
      dispatch({ type: TAG_ERROR, payload: error_msg });
    }
  };

  return (
    <TagContext.Provider
      value={{
        tags: state.tags,
        loading: state.loading,
        getTags,
      }}
    >
      {props.children}
    </TagContext.Provider>
  );
};

export default TagState;
